export default "__VITE_ASSET__e8qAE1N8__"